import { render } from "./ImagePicker.vue?vue&type=template&id=0b6c0883&scoped=true"
import script from "./ImagePicker.vue?vue&type=script&lang=js"
export * from "./ImagePicker.vue?vue&type=script&lang=js"

import "./ImagePicker.vue?vue&type=style&index=0&id=0b6c0883&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b6c0883"]])

export default __exports__